import dayjs from "dayjs";
import { useMemo } from "react";
import { Badge, Button, Card, Table } from "react-bootstrap";
import { fmtNum, formattedTime } from "../../Services/processo/dashboardProcessoUtils";

const RegistroviewDashboardCard = ({
    controle,
    registros = [],
    setShowHist,
    setRegistroModal,
}) => {
    const { minSpec, maxSpec } = useMemo(() => {
        let min = null;
        let max = null;
        let minIsSpec = false;
        let maxIsSpec = false;

        const limits = controle?.especificacao?.limitesDeControle || [];
        
        limits.forEach((l) => {
            const val = Number(l.valor);
            if (isNaN(val)) return;

            const isSpec = l.nome && l.nome.toLowerCase().includes("especificado");

            if ([">", ">="].includes(l.boundRule)) {
                // Se é especificado, sobrescreve qualquer anterior.
                // Se NÃO é especificado, só grava se ainda não tiver achado um especificado.
                if (isSpec) {
                    min = val;
                    minIsSpec = true;
                } else if (!minIsSpec) {
                    min = val;
                }
            } else if (["<", "<="].includes(l.boundRule)) {
                if (isSpec) {
                    max = val;
                    maxIsSpec = true;
                } else if (!maxIsSpec) {
                    max = val;
                }
            }
        });
        return { minSpec: min, maxSpec: max };
    }, [controle]);

    return (
        <Card>
            <Card.Header className="d-flex align-items-center justify-content-between">
                <div>
                    <div>
                        {`${controle?.operacao ?? ""} - ${controle?.nomeParametro ?? ""
                            } - ${controle?.labelUnidade ?? ""}`}
                    </div>
                    <div className="text-muted small d-flex gap-3 align-items-center flex-wrap">
                        {(minSpec !== null || maxSpec !== null) && (
                            <span>
                                <strong>Faixa Específicada:</strong>{' '}
                                {minSpec !== null && maxSpec !== null 
                                    ? `${fmtNum(minSpec)} - ${fmtNum(maxSpec)}`
                                    : minSpec !== null 
                                        ? `>= ${fmtNum(minSpec)}`
                                        : `<= ${fmtNum(maxSpec)}`
                                }
                            </span>
                        )}

                    </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => setShowHist(true)}
                        title="Ver histograma"
                    >
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                        >
                            <rect x="3" y="10" width="3" height="11" rx="1"></rect>
                            <rect x="10" y="6" width="3" height="15" rx="1"></rect>
                            <rect x="17" y="2" width="3" height="19" rx="1"></rect>
                        </svg>{" "}
                        Histograma
                    </Button>
                </div>
            </Card.Header>

            <Card.Body className="p-0" style={{ maxHeight: 450, overflowY: "auto" }}>
                <Table hover responsive className="mb-0">
                    <thead>
                        <tr>
                            <th style={{ width: 110 }}>ID</th>
                            <th style={{ width: 180 }}>Data</th>
                            <th>Valor</th>
                            <th>Frequencia</th>
                            <th style={{ width: 160 }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(registros || []).map((r) => {
                            const alerta = !!r.foraDeEspecificacao;
                            return (
                                <tr
                                    key={r.id}
                                    onClick={() =>
                                        setRegistroModal({
                                            ...r,
                                            unidade: controle?.labelUnidade,
                                        })
                                    }
                                    style={{ cursor: "pointer" }}
                                    title={
                                        alerta
                                            ? `Fora de especificação (${(r.regrasQueFalharam || [])
                                                .map((f) => `${f.boundRule} ${f.valor}`)
                                                .join(", ")})`
                                            : "Clique para detalhes"
                                    }
                                    className={alerta ? "table-warning" : ""}
                                >
                                    <td>{r.id}</td>
                                    <td title={r.data}>
                                        {dayjs(r.data).format("DD/MM/YYYY HH:mm")}
                                    </td>
                                    <td>
                                        {fmtNum(
                                            Number(String(r.valor).replace(",", ".")),
                                            2
                                        )}
                                        {controle?.labelUnidade ? (
                                            <span className="text-muted">
                                                {" "}
                                                {controle.labelUnidade}
                                            </span>
                                        ) : null}
                                    </td>
                                    <td>
                                        {formattedTime(r.frequenciaRealizada || 0)}
                                    </td>
                                    <td>
                                        <Badge bg={alerta ? "danger" : "success"}>
                                            {alerta ? "Fora de especificação" : "OK"}
                                        </Badge>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};

export default RegistroviewDashboardCard;